import { render, staticRenderFns } from "./decoding-assessment.vue?vue&type=template&id=020da421&scoped=true"
import script from "./decoding-assessment.ts?vue&type=script&lang=ts&external"
export * from "./decoding-assessment.ts?vue&type=script&lang=ts&external"
import style0 from "./decoding-assessment.scss?vue&type=style&index=0&id=020da421&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020da421",
  null
  
)

export default component.exports